import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {StartComponent} from "./pages/start/start.component";
import {SignUpComponent} from './pages/sign-up/sign-up.component';
import {QuestionComponent} from './pages/question/question.component';
import {ScoreComponent} from './pages/score/score.component';
import {InstructionsComponent} from './pages/instructions/instructions.component';
import {QuizDoneComponent} from './pages/quiz-done/quiz-done.component';
import {SplashComponent} from './pages/splash/splash.component';
import {AdminComponent} from './pages/admin/admin.component';
import {LoggedInGuard} from './guards/LoggedInGuard';
import {ConfigurationComponent} from './pages/configuration/configuration.component';
import {QuestionConfigComponent} from './pages/question-config/question-config.component';
import {ScoreConfigComponent} from './pages/score-config/score-config.component';
import {ScoreIntroComponent} from './pages/score-intro/score-intro.component';
import {MiscSettingsComponent} from './pages/misc-settings/misc-settings.component';
import {QuizGuard} from './guards/QuizGuard';
import {QuizCooldownComponent} from './pages/quiz-cooldown/quiz-cooldown.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: "splash",
  },
  {
    path: 'splash',
    pathMatch: 'full',
    component: SplashComponent
  },
  {
    path: 'start',
    pathMatch: 'full',
    component: StartComponent
  },
  {
    path: "signup",
    pathMatch: "full",
    component: SignUpComponent,
    canActivate: [QuizGuard]
  },
  {
    path: "questions",
    pathMatch: "full",
    component: QuestionComponent,
    canActivate: [QuizGuard]
  },
  {
    path: "score",
    pathMatch: "full",
    component: ScoreComponent
  },
  {
    path: "instructions",
    pathMatch: "full",
    component: InstructionsComponent,
    canActivate: [QuizGuard]
  },
  {
    path: "quiz-done",
    pathMatch: "full",
    component: QuizDoneComponent
  },
  {
    path: "admin",
    pathMatch: "full",
    component: AdminComponent,
  },
  {
    path: "configuration",
    pathMatch: "full",
    component: ConfigurationComponent,
    canActivate: [LoggedInGuard]
  },
  {
    path: "question-config",
    pathMatch: "full",
    component: QuestionConfigComponent,
    canActivate: [LoggedInGuard]
  },
  {
    path: "score-config",
    pathMatch: "full",
    component: ScoreConfigComponent,
    canActivate: [LoggedInGuard]
  },
  {
    path: "score-intro",
    pathMatch: "full",
    component: ScoreIntroComponent
  },
  {
    path: "misc-settings",
    pathMatch: "full",
    component: MiscSettingsComponent,
    canActivate: [LoggedInGuard]
  },
  {
    path: "quiz-cooldown",
    pathMatch: "full",
    component: QuizCooldownComponent
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
